const BetOfferThreeWayHcp = {
  title: 'Example JSON',
  expectedOutput: 'Full Time, Starts 0-3',
  initialDisplayedCode: `{
    "outcomeId": 2950948554,
    "betOffer": {
      "id": 2385752319,
      "betOfferType": {
        "id": 11, `,
  moreCode: `
        "name":"3-Way Handicap"
      },
      "criterion": {
        "label": "Full Time"
      },
      "outcomes": [
        {
            "id": 2950948551,
            "line": 2000
        },{
            "id": 2950948554,
            "line": 3000
        }]
    },
    "event": {
        "id": 21212322,
        "tags": ["AWAY_HOME"]
    }
}`,
};

export default BetOfferThreeWayHcp;
